import NivelPuestoService from 'src/modules/nivelPuesto/nivelPuestoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'NIVELPUESTO_FORM';

const nivelPuestoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPuestoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await NivelPuestoService.find(id);
      }

      dispatch({
        type: nivelPuestoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nivelPuestoFormActions.INIT_ERROR,
      });

      getHistory().push('/nivel-puesto');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPuestoFormActions.CREATE_STARTED,
      });

      await NivelPuestoService.create(values);

      dispatch({
        type: nivelPuestoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.nivelPuesto.create.success'),
      );

      getHistory().push('/nivel-puesto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nivelPuestoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: nivelPuestoFormActions.UPDATE_STARTED,
      });

      await NivelPuestoService.update(id, values);

      dispatch({
        type: nivelPuestoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.nivelPuesto.update.success'),
      );

      getHistory().push('/nivel-puesto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nivelPuestoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default nivelPuestoFormActions;
